import { create } from "zustand";

const initialState = {
  posts: [],
  isLoading: false,
  error: "",
};

export const usePostsStore = create((set) => ({
  ...initialState,
  setPosts: (value) => set({ posts: value }),
  setIsLoading: (value) => set({ isLoading: value }),
  setError: (value) => set({ error: value }),
  clear: () => set(initialState),
}));
